export const brands = [
    {
        name: "Fiat",
        slug: "fiat",
        logo: "/brands/fiat.png",
    },
    {
        name: "Chevrolet",
        slug: "chevrolet",
        logo: "/brands/chevrolet.png",
    },
    {
        name: "Ford",
        slug: "Ford",
        logo: "/brands/ford.png",
    },
    {
        name: "Renault",
        slug: "renault",
        logo: "/brands/renault.png",
    },
    {
        name: "Volkswagen",
        slug: "volkswagen",
        logo: "/brands/volkswagen.png",
    },
    {
        name: "Toyota",
        slug: "toyota",
        logo: "/brands/toyota.png",
    },
    {
        name: "Honda",
        slug: "honda",
        logo: "/brands/honda.png",
    },
    {
        name: "Hyundai",
        slug: "hyundai",
        logo: "/brands/hyundai.png",
    },
    {
        name: "Audi",
        slug: "audi",
        logo: "/brands/audi.png",
    },
    {
        name: "BMW",
        slug: "bmw",
        logo: "/brands/bmw.png",
    },
    {
        name: "Citroen",
        slug: "citroen",
        logo: "/brands/citroen.png",
    },
    {
        name: "Jeep",
        slug: "jeep",
        logo: "/brands/jeep.png",
    },
    {
        name: "Mercedes",
        slug: "mercedes",
        logo: "/brands/mercedes.png",
    },
    {
        name: "Yamaha",
        slug: "yamaha",
        logo: "/brands/Yamaha.png",
    },

];
